import type { ReactNode } from 'react';

export const symbol_help_center: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M504-257.03q11-11.03 11-27T503.97-311q-11.03-11-27-11T450-310.97q-11 11.03-11 27T450.03-257q11.03 11 27 11T504-257.03ZM605-601q0-52.63-34-83.81Q537-716 479-716q-42 0-75.72 17.47Q369.55-681.06 350-648q-6 9-.94 19.56Q354.11-617.88 365-613q11 5 21.5 1.5T405-624q14-17 32.5-26t41.5-9q32 0 50.5 16t18.5 44q0 20-11 38.5T500-517q-28 26-40 47t-15 48q-1 11 7.5 19.5t20.58 8.5q10.56 0 19.24-8 8.68-8 10.68-20 4-17 13.5-32t29.5-35q32-32 45.5-57.5T605-601ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
		/>
	</svg>
);
